import React from 'react'
import styles from './Style.module.css'

export const BtnSecondary = ({label, handleClick, disabled, selected, varient, customClass, type }) => {
  return (
    <button 
      type={type}
      className={`${styles.BtnSecondary} btn ${customClass}`} 
      varient={varient}
      onClick={handleClick}
      selected={selected} 
      disabled={disabled} 
      title={label}
      >
      {label}
    </button>
  )
}
